import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-card',
  templateUrl: './text-card.component.html',
  styleUrls: ['./text-card.component.scss'],
})
export class TextCardComponent {
  @Input() values: string | number = '1000';
  @Input() valueLabel: string = '';
  @Input() label: string = 'Subtitle';
  @Input() valueColor: string = '#fff';
  @Input() labelColor: string = '#fff';
}
